import { IntlShape } from 'react-intl';

export function handleLoginError(error: any, intl: IntlShape) {
  let errorMessage = {
    title: intl.formatMessage({
      id: 'is.login.generic_error_title',
      defaultMessage: 'Something went wrong',
    }),
    description: intl.formatMessage({
      id: 'is.login.generic_error_description',
      defaultMessage: 'Please try again later',
    }),
  };

  if (error.code && error.code >= 2003 && error.code <= 2006) {
    errorMessage = {
      title: intl.formatMessage({
        id: 'is.login.wrong_email_or_password_title',
        defaultMessage: 'Wrong credentials',
      }),
      description: intl.formatMessage({
        id: 'is.login.wrong_email_or_password_description',
        defaultMessage: 'Invalid username or password',
      }),
    };
  }

  return errorMessage;
}
